import React from 'react'
import IndexPage from '../index'

const IndexPageNl = () => {
    return <IndexPage languageCode="nl" />
}

export default IndexPageNl
